module.exports = __webpack_public_path__ + "img/744.6bf2f1eb.jpg";